import { BackIcon } from "@/app/components/system/Icons";
import { RoundButton } from "@/app/components/system/RoundButton";

interface ScreenHeadProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
}

export function ScreenHead({ title, subtitle, onBack }: ScreenHeadProps) {
  return (
    <header className="screen-head with-back">
      {onBack && (
        <RoundButton onClick={onBack} aria-label="Back">
          <BackIcon size={20} stroke={2} />
        </RoundButton>
      )}
      <div>
        <h1 className="display">{title}</h1>
        {subtitle && <p className="muted-sm">{subtitle}</p>}
      </div>
    </header>
  );
}
